function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);

/* Layout */
import Layout from '@/layout';

/* Router Modules */
// 自动导入 modules 目录下的所有路由文件（与 admin 框架一致）
var modulesFiles = require.context('./modules', true, /\.js$/);
var modulesRouters = modulesFiles.keys().map(function (modulePath) {
  return modulesFiles(modulePath).default;
}).filter(Boolean);

/**
 * constantRoutes
 * 无需动态权限的基础路由，所有角色均可访问
 * 业务路由通过 require.context 自动从 modules/ 目录加载
 */
export var constantRoutes = [].concat(_toConsumableArray(modulesRouters), [{
  path: '/404',
  component: function component() {
    return import('@/views/error-page/404');
  },
  hidden: true
}, {
  path: '/login',
  component: function component() {
    return import('@/views/login/index');
  },
  hidden: true
}, {
  path: '/',
  component: Layout,
  redirect: '/dashboard',
  children: [{
    path: 'dashboard',
    component: function component() {
      return import('@/views/dashboard/index');
    },
    name: 'Dashboard',
    meta: {
      title: '数据看板',
      icon: 'el-icon-data-analysis'
    }
  }]
},
// 404 页面必须放在末尾
{
  path: '*',
  redirect: function redirect(to) {
    return {
      path: '/404',
      query: {
        from: to.fullPath
      }
    };
  },
  hidden: true
}]);

/**
 * asyncRoutes
 * 由后端菜单驱动的动态路由（当前为空，保留与 admin 框架一致的结构）
 */
export var asyncRoutes = [];
var createRouter = function createRouter() {
  return new Router({
    mode: 'history',
    scrollBehavior: function scrollBehavior() {
      return {
        y: 0
      };
    },
    routes: constantRoutes
  });
};
var router = createRouter();
export function resetRouter() {
  var newRouter = createRouter();
  router.matcher = newRouter.matcher;
}
export default router;